import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core'
import { AbstractControl, FormControl } from '@angular/forms'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import {
  BiddingItemEntity,
  DonationItemEntity,
  PurchaseItemEntity,
  RaffleItemEntity,
} from 'libs/gb-front/item/data-access/src/lib/+state/items.models'
import { EventTicketPackageEntity } from 'libs/gb-front/event-tickets/data-access-event-ticket-packages/src/lib/+state/event-ticket-packages.models'
import { Observable, combineLatest, debounceTime, map } from 'rxjs'
import { GbValidationMessagesService } from './gb-validation-messages.service'

@UntilDestroy()
@Component({
  selector: 'gb-validation-messages',
  templateUrl: './gb-validation-messages.component.html',
  styleUrls: ['./gb-validation-messages.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbValidationMessagesComponent implements OnChanges {
  @Input() control!: FormControl | AbstractControl
  @Input() item?:
    | DonationItemEntity
    | BiddingItemEntity
    | PurchaseItemEntity
    | RaffleItemEntity
    | EventTicketPackageEntity
    | null

  public errorMessage$?: Observable<string>

  constructor(private validationMessagesService: GbValidationMessagesService) {}

  ngOnChanges(): void {
    this.errorMessage$ = combineLatest([this.control.valueChanges, this.control.statusChanges]).pipe(
      untilDestroyed(this),
      debounceTime(100),
      map((): string => {
        const { dirty, invalid, touched } = this.control
        return (dirty || touched) && invalid
          ? this.validationMessagesService.getValidatorErrorMessage(this.control, this.item)
          : ''
      }),
    )
  }
}
